import Vue from 'vue'
import store from 'store'
import moment from 'moment-timezone'

const FORMATS = {
  0: {
    'en-us': 'MM/DD/YYYY',
    'zh-cn': 'YYYY/MM/DD'
  },
  1: {
    'en-us': 'MMM DD, YYYY',
    'zh-cn': 'YYYY/MM/DD'
  },
  2: {
    'en-us': 'MMM, YYYY',
    'zh-cn': 'YYYY/MM'
  },
  3: {
    'en-us': 'MMM DD',
    'zh-cn': 'MM/DD'
  },
  4: {
    'en-us': 'HH:mm',
    'zh-cn': 'HH:mm'
  },
  5: {
    'en-us': 'HH:mm:ss',
    'zh-cn': 'HH:mm:ss'
  }
}
const ONLY_NUMBER = /^[0-9]+$/
const SPLICE_NUMBER = /^[0-9]+(-[0-9]+)+$/
/**
 * 格式化日期，不同环境下的时间格式，支持枚举，拼接，自定义格式
 * @param {string | number} mode - 格式化模式
 * @param { string } timezone 时区
 *
 * 拼接模式示例：
 * date | formatDate(1) => 2019/01/01
 * date | formatDate('1-5') => 2019/01/01 12:12:12
 * date | formatDate('2-5') => 2019/01 12:12:12
 *
 * 自定义格式示例：
 * date | formatDate('YYYY年MM月DD日') => 2020年01月01日
 */
Vue.filter('formatDate', (value, mode = 0, timezone) => {
  if (value) {
    const language = store.getters.language
    let format = FORMATS[0][language]
    if (ONLY_NUMBER.test(mode)) {
      format = (FORMATS[mode] || FORMATS[0])[language]
    } else {
      if (SPLICE_NUMBER.test(mode)) {
        const arr = []
        mode.split('-').forEach(t => {
          FORMATS[t] && arr.push(FORMATS[t][language])
        })
        format = arr.join(' ')
      } else {
        format = mode
      }
    }
    const time = timezone ? moment.tz(value, timezone) : moment(value)

    return time.format(format)
  }
})
